export default "__VITE_ASSET__gC1jmdn3__"